module.exports = __webpack_public_path__ + "img/recent.a1fa8166.svg";